import { createMediaQuery } from "./utils/createMediaQuery";
import { queries } from "./viewports";

const small = createMediaQuery(queries.small, "small");
const medium = createMediaQuery(queries.medium, "medium");
const large = createMediaQuery(queries.large, "large");
const xlarge = createMediaQuery(queries.xlarge, "xlarge");
const xxlarge = createMediaQuery(queries.xxlarge, "xxlarge");

const xsmallMin = createMediaQuery({ min: queries.xsmall.min }, "xsmallMin");
const smallMin = createMediaQuery({ min: queries.small.min }, "smallMin");
const mediumMin = createMediaQuery({ min: queries.medium.min }, "mediumMin");
const largeMin = createMediaQuery({ min: queries.large.min }, "largeMin");
const xlargeMin = createMediaQuery({ min: queries.xlarge.min }, "xlargeMin");
const xxlargeMin = createMediaQuery({ min: queries.xxlarge.min }, "xxlargeMin");

const xsmallMax = createMediaQuery({ max: queries.xsmall.max }, "xsmallMax");
const smallMax = createMediaQuery({ max: queries.small.max }, "smallMax");
const mediumMax = createMediaQuery({ max: queries.medium.max }, "mediumMax");
const largeMax = createMediaQuery({ max: queries.large.max }, "largeMax");
const xlargeMax = createMediaQuery({ max: queries.xlarge.max }, "xlargeMax");
const xxlargeMax = createMediaQuery({ max: queries.xxlarge.max }, "xxlargeMax");

export const mediaQueries = {
  small,
  medium,
  large,
  xlarge,
  xxlarge,

  xsmallMin,
  smallMin,
  mediumMin,
  largeMin,
  xlargeMin,
  xxlargeMin,

  xsmallMax,
  smallMax,
  mediumMax,
  largeMax,
  xlargeMax,
  xxlargeMax,
};
